import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mv-msg-search-bar"
}
const _hoisted_2 = {
  key: 0,
  class: "mv-msg-search-count"
}
const _hoisted_3 = {
  key: 0,
  class: "mv-msgs-loading"
}
const _hoisted_4 = {
  key: 0,
  class: "mv-load-more-row"
}
const _hoisted_5 = {
  key: 1,
  class: "mv-no-more"
}
const _hoisted_6 = ["data-msg-id"]
const _hoisted_7 = {
  key: 0,
  class: "mv-msg-act"
}
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 1,
  class: "mv-msg-av-spacer"
}
const _hoisted_11 = {
  key: 0,
  class: "mv-priv-tag"
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["href"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "mv-bubble-ts" }
const _hoisted_17 = ["title"]
const _hoisted_18 = {
  key: 0,
  width: "8",
  height: "8",
  viewBox: "0 0 8 8",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round"
}
const _hoisted_19 = {
  key: 1,
  width: "14",
  height: "8",
  viewBox: "0 0 14 8",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_20 = {
  key: 2,
  width: "10",
  height: "8",
  viewBox: "0 0 10 8",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_21 = {
  key: 1,
  class: "mv-window-banner"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled", "title"]
const _hoisted_24 = { class: "mv-ta-wrap" }
const _hoisted_25 = {
  key: 0,
  class: "mv-files-preview"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["placeholder", "disabled"]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 0,
  class: "mv-spinner-sm"
}
const _hoisted_30 = {
  key: 1,
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}

import { ref, computed, watch } from 'vue'
import type { ProcessedMsg, ChatMessage } from '@/types/chat'
import { avatarColor, initials } from '@/composables/useHelpers'
import { fmtTs, senderName } from '@/utils/mobileFormat'
import { useMessageSearch } from '@/composables/useMessageSearch'
import { useMessageSender } from '@/composables/useMessageSender'
import { usePermission } from '@/composables/usePermission'


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileChatMessages',
  props: {
    processedMsgs: {},
    loadingMsgs: { type: Boolean },
    loadingMore: { type: Boolean },
    noMoreMsgs: { type: Boolean },
    messageSignature: {},
    convId: {},
    token: {},
    contactPhone: {},
    loadMoreMsgs: { type: Function },
    windowClosed: { type: Boolean },
    assigneeId: {},
    myAgentId: {},
    labels: {},
    status: {}
  },
  emits: ["message-created", "auto-assigned", "labels-changed", "status-changed"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const { can } = usePermission()

const props = __props

const emit = __emit

const msgsEl      = ref<HTMLElement | null>(null)
const taEl        = ref<HTMLTextAreaElement | null>(null)
const fileInputEl = ref<HTMLInputElement | null>(null)
const draft       = ref('')
const files       = ref<File[]>([])
const notaInterna = ref(false)

const canSend = computed(() => draft.value.trim().length > 0 || files.value.length > 0)

// Notas internas exigem a janela aberta (mesmo composer da mensagem normal) — se a janela
// fechar enquanto o toggle está ativo, desativa pra não deixar o composer num estado inválido.
watch(() => props.windowClosed, (closed) => { if (closed) notaInterna.value = false })

const processedMsgsRef = computed(() => props.processedMsgs)
const noMoreMsgsLocal   = ref(props.noMoreMsgs)
watch(() => props.noMoreMsgs, v => { noMoreMsgsLocal.value = v })

const {
  msgSearchOpen, msgSearchQuery, msgSearchActive, msgSearchLoading, msgCurrentIdx, msgSearchInputEl,
  msgMatchIds, getSig, highlightMsgHtml,
  openMsgSearch, closeMsgSearch, doMsgSearch, goNextMsg, goPrevMsg,
} = useMessageSearch({
  processedMsgs: processedMsgsRef,
  msgsEl,
  messageSignature: () => props.messageSignature,
  loadMoreMsgs: props.loadMoreMsgs,
  noMoreMsgs: noMoreMsgsLocal,
})

function onMsgsScroll() {
  if (msgsEl.value && msgsEl.value.scrollTop < 60) props.loadMoreMsgs()
}

function scrollBottom() {
  if (msgsEl.value) msgsEl.value.scrollTop = msgsEl.value.scrollHeight
}

const { sending, sendMsg } = useMessageSender({
  getConvId: () => props.convId,
  getToken: () => props.token,
  getContactPhone: () => props.contactPhone,
  getSig,
  draft,
  files,
  isPrivate: notaInterna,
  fileInputEl,
  taEl,
  scrollBottom,
  getAssigneeId: () => props.assigneeId,
  getMyAgentId: () => props.myAgentId,
  getLabels: () => props.labels,
  getStatus: () => props.status,
  onMessageCreated: (msg, convId) => emit('message-created', msg, convId),
  onAutoAssigned: (convId, agentId) => emit('auto-assigned', convId, agentId),
  onLabelsChanged: (convId, labels) => emit('labels-changed', convId, labels),
  onStatusChanged: (convId, status) => emit('status-changed', convId, status),
})

function onFilePick(e: Event) {
  const input = e.target as HTMLInputElement
  if (input.files) { files.value.push(...Array.from(input.files)); input.value = '' }
}

function growTa() {
  const el = taEl.value
  if (!el) return
  el.style.height = 'auto'
  el.style.height = Math.min(el.scrollHeight, 100) + 'px'
}

__expose({ openMsgSearch, scrollBottom, getScrollEl: () => msgsEl.value })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(msgSearchOpen))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives(_createElementVNode("input", {
            ref_key: "msgSearchInputEl",
            ref: msgSearchInputEl,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(msgSearchQuery) ? (msgSearchQuery).value = $event : null)),
            class: "mv-msg-search-input",
            placeholder: "Buscar nas mensagens…",
            onKeydown: [
              _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_unref(doMsgSearch) && _unref(doMsgSearch)(...args)), ["enter"])),
              _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_unref(closeMsgSearch) && _unref(closeMsgSearch)(...args)), ["escape"]))
            ]
          }, null, 544), [
            [_vModelText, _unref(msgSearchQuery)]
          ]),
          (_unref(msgSearchActive))
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(msgMatchIds).length ? (_unref(msgCurrentIdx) + 1) + '/' + _unref(msgMatchIds).length : '0 resultados'), 1))
            : _createCommentVNode("", true),
          (_unref(msgMatchIds).length)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "mv-msg-search-nav",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(goPrevMsg) && _unref(goPrevMsg)(...args))),
                title: "Anterior"
              }, [...(_cache[11] || (_cache[11] = [
                _createElementVNode("svg", {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("polyline", { points: "18 15 12 9 6 15" })
                ], -1)
              ]))]))
            : _createCommentVNode("", true),
          (_unref(msgMatchIds).length)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "mv-msg-search-nav",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(goNextMsg) && _unref(goNextMsg)(...args))),
                title: "Próximo"
              }, [...(_cache[12] || (_cache[12] = [
                _createElementVNode("svg", {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("polyline", { points: "6 9 12 15 18 9" })
                ], -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "mv-msg-search-close",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(closeMsgSearch) && _unref(closeMsgSearch)(...args)))
          }, [...(_cache[13] || (_cache[13] = [
            _createElementVNode("svg", {
              width: "12",
              height: "12",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("line", {
                x1: "18",
                y1: "6",
                x2: "6",
                y2: "18"
              }),
              _createElementVNode("line", {
                x1: "6",
                y1: "6",
                x2: "18",
                y2: "18"
              })
            ], -1)
          ]))])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "mv-msgs",
      ref_key: "msgsEl",
      ref: msgsEl,
      onScroll: onMsgsScroll
    }, [
      (__props.loadingMsgs || _unref(msgSearchLoading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[14] || (_cache[14] = [
            _createElementVNode("div", { class: "mv-spinner" }, null, -1)
          ]))]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (__props.loadingMore)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("div", { class: "mv-spinner-sm" }, null, -1)
                ]))]))
              : (__props.noMoreMsgs)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, "início da conversa"))
                : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.processedMsgs, (msg) => {
              return (_openBlock(), _createElementBlock("div", {
                key: msg.id,
                class: _normalizeClass(["mv-msg-row", { out: msg.message_type === 1, inn: msg.message_type === 0, act: msg.message_type === 2, 'msg-match-current': _unref(msgSearchActive) && _unref(msgMatchIds)[_unref(msgCurrentIdx)] === msg.id }]),
                "data-msg-id": msg.id
              }, [
                (msg.message_type === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(msg.content), 1))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (msg.showAvatar)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "mv-msg-av",
                            style: _normalizeStyle({ background: _unref(avatarColor)(_unref(senderName)(msg)) })
                          }, [
                            (msg.sender?.thumbnail && msg.message_type === 1)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: msg.sender.thumbnail,
                                  alt: _unref(senderName)(msg),
                                  onError: _cache[6] || (_cache[6] = (e) => (e.target as HTMLImageElement).style.display='none')
                                }, null, 40, _hoisted_8))
                              : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(initials)(_unref(senderName)(msg))), 1))
                          ], 4))
                        : (_openBlock(), _createElementBlock("div", _hoisted_10)),
                      _createElementVNode("div", {
                        class: _normalizeClass(["mv-bubble", { 'mv-bubble--priv': msg.private }])
                      }, [
                        (msg.private)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, [...(_cache[16] || (_cache[16] = [
                              _createElementVNode("svg", {
                                width: "10",
                                height: "10",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("rect", {
                                  x: "3",
                                  y: "11",
                                  width: "18",
                                  height: "11",
                                  rx: "2"
                                }),
                                _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
                              ], -1),
                              _createTextVNode(" Nota interna ", -1)
                            ]))]))
                          : _createCommentVNode("", true),
                        (msg.content)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "mv-bubble-text",
                              innerHTML: _unref(highlightMsgHtml)(msg.content, msg.message_type === 1, __props.messageSignature)
                            }, null, 8, _hoisted_12))
                          : _createCommentVNode("", true),
                        (msg.attachments?.length)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(msg.attachments, (att) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: att.id,
                                class: "mv-att"
                              }, [
                                (att.file_type === 'image')
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: att.data_url,
                                      target: "_blank",
                                      rel: "noopener"
                                    }, [
                                      _createElementVNode("img", {
                                        src: att.thumb_url || att.data_url,
                                        class: "mv-att-img",
                                        alt: "imagem",
                                        loading: "lazy"
                                      }, null, 8, _hoisted_14)
                                    ], 8, _hoisted_13))
                                  : (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      href: att.data_url,
                                      target: "_blank",
                                      rel: "noopener",
                                      class: "mv-att-file"
                                    }, [
                                      _cache[17] || (_cache[17] = _createElementVNode("svg", {
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round"
                                      }, [
                                        _createElementVNode("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }),
                                        _createElementVNode("polyline", { points: "14 2 14 8 20 8" })
                                      ], -1)),
                                      _createTextVNode(" " + _toDisplayString(att.extension?.toUpperCase() || 'Arquivo'), 1)
                                    ], 8, _hoisted_15))
                              ]))
                            }), 128))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_16, [
                          _createTextVNode(_toDisplayString(_unref(fmtTs)(msg.created_at)) + " ", 1),
                          (msg.message_type === 1)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(["mv-msg-status", 's-'+(msg.status||'sent')]),
                                title: msg.status === 'read' ? 'Lido' : msg.status === 'delivered' ? 'Entregue' : msg.status === 'failed' ? 'Falhou' : 'Enviado'
                              }, [
                                (msg.status === 'failed')
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_18, [...(_cache[18] || (_cache[18] = [
                                      _createElementVNode("line", {
                                        x1: "1",
                                        y1: "1",
                                        x2: "7",
                                        y2: "7"
                                      }, null, -1),
                                      _createElementVNode("line", {
                                        x1: "7",
                                        y1: "1",
                                        x2: "1",
                                        y2: "7"
                                      }, null, -1)
                                    ]))]))
                                  : (msg.status === 'read' || msg.status === 'delivered')
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_19, [...(_cache[19] || (_cache[19] = [
                                        _createElementVNode("polyline", { points: "1,4 3.5,6.5 9,1" }, null, -1),
                                        _createElementVNode("polyline", { points: "5,4 7.5,6.5 13,1" }, null, -1)
                                      ]))]))
                                    : (_openBlock(), _createElementBlock("svg", _hoisted_20, [...(_cache[20] || (_cache[20] = [
                                        _createElementVNode("polyline", { points: "1,4 3.5,6.5 9,1" }, null, -1)
                                      ]))]))
                              ], 10, _hoisted_17))
                            : _createCommentVNode("", true)
                        ])
                      ], 2)
                    ], 64))
              ], 10, _hoisted_6))
            }), 128))
          ], 64))
    ], 544),
    (__props.windowClosed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[21] || (_cache[21] = [
          _createElementVNode("svg", {
            width: "13",
            height: "13",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("circle", {
              cx: "12",
              cy: "12",
              r: "10"
            }),
            _createElementVNode("line", {
              x1: "12",
              y1: "8",
              x2: "12",
              y2: "12"
            }),
            _createElementVNode("line", {
              x1: "12",
              y1: "16",
              x2: "12.01",
              y2: "16"
            })
          ], -1),
          _createElementVNode("span", null, "Janela de 24h do WhatsApp encerrada — responda pelo desktop com um template", -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["mv-composer", { 'mv-composer--priv': notaInterna.value }])
    }, [
      _createElementVNode("label", {
        class: _normalizeClass(["mv-attach-btn", { 'mv-attach-disabled': __props.windowClosed || notaInterna.value }]),
        title: "Anexar"
      }, [
        _createElementVNode("input", {
          type: "file",
          multiple: "",
          hidden: "",
          ref_key: "fileInputEl",
          ref: fileInputEl,
          disabled: __props.windowClosed || notaInterna.value,
          onChange: onFilePick
        }, null, 40, _hoisted_22),
        _cache[22] || (_cache[22] = _createElementVNode("svg", {
          width: "18",
          height: "18",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          _createElementVNode("path", { d: "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" })
        ], -1))
      ], 2),
      (_unref(can)('messages.privateNote'))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(["mv-priv-btn", { 'mv-priv-btn--active': notaInterna.value }]),
            disabled: __props.windowClosed,
            onClick: _cache[7] || (_cache[7] = ($event: any) => (notaInterna.value = !notaInterna.value)),
            title: notaInterna.value ? 'Nota interna ativada' : 'Marcar como nota interna'
          }, [...(_cache[23] || (_cache[23] = [
            _createElementVNode("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("rect", {
                x: "3",
                y: "11",
                width: "18",
                height: "11",
                rx: "2"
              }),
              _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
            ], -1)
          ]))], 10, _hoisted_23))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_24, [
        (files.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (f, i) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: i,
                  class: "mv-file-pill"
                }, [
                  _createTextVNode(_toDisplayString(f.name.slice(0, 20)) + _toDisplayString(f.name.length > 20 ? '…' : '') + " ", 1),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (files.value.splice(i, 1))
                  }, "×", 8, _hoisted_26)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("textarea", {
          ref_key: "taEl",
          ref: taEl,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((draft).value = $event)),
          class: "mv-ta",
          placeholder: notaInterna.value ? 'Nota interna — só a equipe vê…' : (__props.windowClosed ? 'Só é possível responder com template' : 'Mensagem…'),
          disabled: __props.windowClosed,
          rows: "1",
          onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_unref(sendMsg) && _unref(sendMsg)(...args)), ["exact","prevent"]), ["enter"])),
          onInput: growTa
        }, null, 40, _hoisted_27), [
          [_vModelText, draft.value]
        ])
      ]),
      _createElementVNode("button", {
        class: "mv-send-btn",
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_unref(sendMsg) && _unref(sendMsg)(...args))),
        disabled: !canSend.value || _unref(sending) || __props.windowClosed
      }, [
        (_unref(sending))
          ? (_openBlock(), _createElementBlock("span", _hoisted_29))
          : (_openBlock(), _createElementBlock("svg", _hoisted_30, [...(_cache[24] || (_cache[24] = [
              _createElementVNode("line", {
                x1: "22",
                y1: "2",
                x2: "11",
                y2: "13"
              }, null, -1),
              _createElementVNode("polygon", { points: "22 2 15 22 11 13 2 9 22 2" }, null, -1)
            ]))]))
      ], 8, _hoisted_28)
    ], 2)
  ], 64))
}
}

})